// unity webGL instance loader

export default function startUnity(buildFolder, buildName, canvasId) 
{
    const canvas = document.getElementById(canvasId);    

    const buildUrl = buildFolder;
    const loaderUrl = `${buildUrl}/${buildName}.loader.js`;

    const config = 
    {
        dataUrl: `${buildUrl}/${buildName}.data`,
        frameworkUrl: `${buildUrl}/${buildName}.framework.js`,
        codeUrl: `${buildUrl}/${buildName}.wasm`,
        //streamingAssetsUrl: "StreamingAssets",
        companyName: "NootnootStudios",
        productName: "CricketBallBallance",
        productVersion: "1.0",
        //showBanner: unityShowBanner
        // Add these to disable logs
        showBanner: false,  // Disables Unity banner
        
        // Override print and printErr functions
        print: function() {},  // Disable standard output
        printErr: function() {}  // Disable error output
    };    

    // Prevent multiple identical <script> insertions
    let existingScript = document.querySelector(`script[src="${loaderUrl}"]`);
    document.querySelector("#unity-loading-bar").style.display = "block";

    if (!existingScript) 
    {
        
        const script = document.createElement("script");
        script.src = loaderUrl;

        script.onload = () => 
        {
            canvas.style.visibility = "hidden"; // hide canvas while loading
            createUnityInstance(canvas, config, (progress) => {
                const bar = document.querySelector("#unity-progress-bar-full");
                if (bar) bar.style.width = (progress * 100) + "%";
            }).then((unityInstance) => 
            {
                const loadingBar = document.querySelector("#unity-loading-bar");
                if (loadingBar) loadingBar.style.display = "none";
                canvas.style.visibility = "visible"; // reveal canvas once ready
            });
        };

        document.body.appendChild(script);
    } 
    else if (window.createUnityInstance) 
    {
        canvas.style.visibility = "hidden"; // hide canvas while loading
        // Loader is already loaded; create a new instance without reinjecting script
        createUnityInstance(canvas, config, (progress) => 
        {
            const bar = document.querySelector("#unity-progress-bar-full");
            if (bar) bar.style.width = "0%"; // reset before each load
            if (bar) bar.style.width = (progress * 100) + "%";
        }).then((unityInstance) => 
        {
            const loadingBar = document.querySelector("#unity-loading-bar");
            if (loadingBar) loadingBar.style.display = "none";
            canvas.style.visibility = "visible"; // reveal canvas once ready
        });
    }

}
